export const SITE_NAME = 'Family Tree Maker';
export const SITE_DOMAIN = 'familytreemakerchat.com';
export const SITE_URL = 'https://www.familytreemakerchat.com';
export const SUPPORT_EMAIL = 'support@familytreemakerchat.com';

/** Lead Desk — form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_05bc02d970d0550e806a4335f97ac0d6b2c002d3a031aaad';
